import React, { FC, useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { useHistory } from 'react-router'
import { Tab, Tabs as MuiTabs, IconButton } from '@material-ui/core'
import { Path } from 'core/Routes'
import { useTranslation } from 'react-i18next'
import { theme } from 'ui'
import vls, { storageKeys } from 'utils/vls'
import useStore from 'store'
import { useLocation } from "react-router-dom";
import { useNotifications } from 'store/NotificationsContext';

import couponsIcon from 'assets/png/couponsIcon.png'

import isMobile from 'utils/isMobile'
import icon1 from 'assets/tabAnimation/icon_1.json'
import icon2 from 'assets/tabAnimation/icon_2.json'
import icon3 from 'assets/tabAnimation/icon_3.json'
import icon4 from 'assets/tabAnimation/icon_4.json'
import icon5 from 'assets/tabAnimation/icon_5.json'
import icon6 from 'assets/tabAnimation/icon_6.json'
import icon7 from 'assets/tabAnimation/icon_7.json'
import icon8 from 'assets/tabAnimation/icon_8.json'
import { CouponIcon } from 'pages/Home/Coupons/icons'
import Lottie from 'react-lottie-player'
import { FeatureIds } from 'utils/types'
import { getTotzeretColorsByCategory, isTotzeret } from 'service/whiteLable'
import { canShowMapTab, canShowPopulationManagementTab } from 'utils/roles'

const w = window.innerWidth

const MobileTab = styled(Tab)`
  color: ${p => isTotzeret ? '#394248' : p.selected ? theme.color.white : '#ffffffcc'} !important;
  font-weight: ${p => p.selected ? 'bold' : 'normal'};
  padding: 0;
  min-width: unset;
  .MuiTab-wrapper {
    flex-direction: column;
    margin-bottom: 1em;
    & > *:first-child {
      margin-bottom: 0 !important;
    }
    svg {
      width: 1em;
      margin-bottom: 0 !important;
    }
    img {
      width: 2em;
    }
  }
  .MuiTab-labelIcon {
    min-height: auto !important;
  }
`

const NotMobileTab = styled(Tab)`
  color: ${p => isTotzeret ? '#394248' : p.selected ? theme.color.white : '#ffffffcc'} !important;
  font-weight: ${p => p.selected ? 'bold' : 'normal'};
  ${isTotzeret ? 'font-size: 16px;' : ''}
  ${isTotzeret ? 'min-height: 100%;' : ''}
  min-width: 66px;
  .MuiTab-wrapper {
    flex-direction: row;
    svg {
      width: 2em;
      margin-bottom: 0 !important;
    }
    img {
      width: 2em;
    }
  }
  .MuiTab-labelIcon {
    min-height: auto !important;
  }
`

const TabsWrap = styled(MuiTabs)`
  background: ${isTotzeret ? 'white' : theme.color.mekomiBlack};
  ${isTotzeret ? `min-height: 100%;
  .MuiTabs-scroller {
    display: flex!important;
    justify-content: center!important;
  }` : ''}

  .MuiTabs-flexContainer {
    @media(max-width: 1081px) {
      justify-content: space-between;
      width: calc(100vw - 40px);
    }
  }
  .MuiTabs-indicator {
    background-color: ${p => isTotzeret ? p.indicatorColor : theme.color.whiteBackground};
    z-index:1;
    width: 45px !important;
    height: 43px;
    transform: translateX(${isMobile() ? `${w / 100}px` : '18px'}) translateY(40px) rotate(45deg);
    border-radius: 7px;
  }
  &:after{
    height: 1px;
    background: ${theme.color.black};
  }
`
const NotificationsNumber = styled.div`
display: flex;
width: 30px;
height: 19px;
padding: 2px 4px;
justify-content: center;
align-items: center;
gap: 10px;
flex-shrink: 0;
border-radius: 100px;
background: #DF0000;
position: absolute;
top: 13px;
left: 0px;
z-index: 1001;
color: white;
font-size: 12px;
font-weight: bold;
@media(max-width: 768px) {
  top: 28px;
  left: 0px;
  font-size: 10px;
}
`

const DefaultTab = isMobile() ? MobileTab : NotMobileTab

const getDefaultTab = () => {
  if (window.location.href.endsWith(Path.COMMUNITY)) {
    return FeatureIds.PORTAL
  }
  if (window.location.href.endsWith(Path.COUPONS)) {
    return FeatureIds.COUPONS
  }
  if (window.location.href.endsWith(Path.CONTACTS)) {
    return FeatureIds.CONTACTS
  }
  if (window.location.href.endsWith(Path.MESSAGES)) {
    return FeatureIds.MESSAGING
  }
  if (window.location.href.includes(Path.BUDGET)) {
    return FeatureIds.BUDGET
  }
  if (window.location.href.includes(Path.PROTOCOLS)) {
    return FeatureIds.PROTOCOLS
  }
  if (window.location.href.includes(Path.MAP)) {
    return FeatureIds.MAP
  }
  if (window.location.href.endsWith(Path.SERVICECALL) || window.location.href.endsWith(Path.SERVICE_GROUPS)) {
    return FeatureIds.SERVICE
  }
  if (window.location.href.endsWith(Path.TEST)) {
    return FeatureIds.TEST
  }
  return FeatureIds.MESSAGING //Defalut is Path.MESSAGES
}

const W = 50
const H = 40

const Tabs: FC = () => {
  const { t } = useTranslation('home')
  const [tab, setTab] = useState(getDefaultTab())
  const [playAnimationTab, setPlayAnimationTab] = useState(0)
  const h = useHistory()
  const { user, groups, messages, modulesStore } = useStore()
  const l = useLocation()
  const { communityFeatures } = modulesStore;
  const { notifications } = useNotifications();

  const unreadNotificationsCount: number = notifications.filter(n => !n.read).length;

  const handleTab = (_: any, v: FeatureIds) => {
    switch (v) {
      case FeatureIds.COUPONS:
        h.push(modulesStore.showCouponFeature() ? Path.COUPONS : Path.MESSAGES)
        break;
      case FeatureIds.TEST:
        h.push(Path.TEST)
        break;
      case FeatureIds.PROTOCOLS:
        h.push(Path.PROTOCOLS)
        break;  
      case FeatureIds.PORTAL:
        h.push(Path.COMMUNITY)
        break;
      case FeatureIds.CONTACTS:
        h.push(Path.CONTACTS)
        break;
      case FeatureIds.MESSAGING:
        groups.setCurrentGroupId(groups?.currentUserGroups?.[0]?.group?.id)
        // We are pushing to GROUPS and only then redirecting to MESSAGES there in routes
        h.push(isMobile() ? Path.GROUPS : Path.MESSAGES);
        break;
      case FeatureIds.BUDGET:
        h.push(Path.BUDGET)
        break;
      case FeatureIds.SERVICE:
        groups.setCurrentGroupId(groups.mcEntityGroup ? groups.mcEntityGroup.id : groups?.currentSupportGroups?.[0]?.group.id)
        h.push(isMobile() ? Path.SERVICE_GROUPS : Path.SERVICECALL)
        break;
      case FeatureIds.MAP:
        h.push(Path.MAP)
        break;
      default:
        return;
    }
    setPlayAnimationTab(v)
  }

  useEffect(() => {
    setTab(getDefaultTab());
  }, [l.pathname])

  useEffect(() => {
    if (user.userProfileOpen) {
      user.closeUserProfile()
    }
  }, [tab])

  useEffect(() => {
    if (groups?.currentGroup?.group?.duplex === 1 && l.pathname === Path.MESSAGES) {
      h.push(Path.SERVICECALL)
    }
  }, [groups.currentGroup])
  useEffect(() => {
    if (!groups?.currentGroup?.group.parent_id && groups?.currentGroup?.group?.duplex === 0 && l.pathname === Path.SERVICECALL) {
      h.push(Path.MESSAGES)
    }
  }, [groups.currentGroup])

  const getIndicatorColor = () => {
    if (l.pathname !== '/home/messages' && l.pathname !== '/home/servicecall') {
      return theme.color.whiteBackground;
    }
    if (isTotzeret) {
      return getTotzeretColorsByCategory(groups.currentGroup?.group?.description?.category).secondary
    }
    return groups.currentGroup?.group?.description?.color || theme.color.whiteBackground
  }

  const indicatorColor = getIndicatorColor();
  const tabsData = [
    { icon: icon1, lable: t`community`, tabValue: FeatureIds.PORTAL },
    { icon: icon2, lable: t`contacts`, tabValue: FeatureIds.CONTACTS },
    { icon: CouponIcon, lable: 'הטבות', tabValue: FeatureIds.COUPONS },
    { icon: icon3, lable: t`messages`, tabValue: FeatureIds.MESSAGING },
    { icon: icon4, lable: t`payments`, tabValue: FeatureIds.BUDGET },
    { icon: icon5, lable: t`serviceCall`, tabValue: FeatureIds.SERVICE },
    { icon: icon8, lable: `פרוטוקולים`, tabValue: FeatureIds.PROTOCOLS },
  ];

  if (canShowPopulationManagementTab()) {
    tabsData.push({ icon: icon7, lable: `אוכלוסיה`, tabValue: FeatureIds.TEST })
  }

  // is manager
  if (canShowMapTab()) {
    tabsData.push({ icon: icon6, lable: t`map`, tabValue: FeatureIds.MAP })
  }

  const enableTabs = () => {
    if (!communityFeatures.length) {
      return [];
    }

    return tabsData.filter((feature) => {
      if (feature.tabValue === FeatureIds.COUPONS) {
        return modulesStore.showCouponFeature();
      }

      if (feature.tabValue === FeatureIds.TEST) {
        return modulesStore.showPopulationFeature();
      }

      if (feature.tabValue === FeatureIds.MAP) {
        return true;
      }

      if (feature.tabValue === FeatureIds.PROTOCOLS) {
        return modulesStore.showProtocolsFeature();
      }

      const findedFeature = communityFeatures.find((communityFeature) => feature.tabValue === communityFeature.id);
      if (!findedFeature) {
        return true;
      }

      return findedFeature.enabled;
    })
  }

  const renderDefaultTab = ({ tabValue, lable, icon }: { tabValue: FeatureIds, lable: string, icon: any }) => (
    <DefaultTab value={tabValue} selected={tab === tabValue} label={lable} aria-label={lable} icon={!isTotzeret ?
      (tabValue === FeatureIds.COUPONS ? <div style={{ width: W, height: H, objectFit: 'contain' }}> <img src={couponsIcon} alt={lable} style={{ width: W, height: H, objectFit: 'contain' }} />{unreadNotificationsCount > 0 && <NotificationsNumber>{unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount}</NotificationsNumber>}</div> :
        <Lottie
          loop={0}
          animationData={icon}
          onComplete={() => setPlayAnimationTab(-1)}
          play={playAnimationTab === tabValue}
          style={{ width: W, height: H }}
        />) : undefined
    } />
  )

  return (
    <TabsWrap value={tab} onChange={handleTab} indicatorColor={indicatorColor} component={'nav'}>
      {enableTabs().map((tabData) => renderDefaultTab(tabData))}
    </TabsWrap>
  )
}

export default observer(Tabs)